// import DuplicateDataModal from "../components/Modals/DuplicateModal";
import { customDateFormat } from "../utils/helperFunctions";

export const userListColumns = [
  {
    accessorKey: "email",
    header: "Email",
    enableSorting: false,
    // size:100
  },
  {
    accessorKey: "country",
    header: "Country",
    enableSorting: false,
    size: 60,
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
  },
  {
    accessorKey: "language",
    header: "Language",
    enableSorting: false,
    size: 60,
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
  },
  {
    accessorKey: "isVerified",
    header: "Verified",
    size: 60,
    Cell: ({ cell }) => (cell?.getValue() ? "True" : "False"),
    enableSorting: false,
  },
  {
    accessorKey: "state",
    header: "State",
    size: 60,
    Cell: ({ cell }) => (cell?.getValue() ? cell.getValue() : "N/A"),
    enableSorting: false,
  },
  {
    accessorKey: "createdAt",
    header: "Created At",
    size: 60,
    Cell: ({ cell }) =>
      cell?.getValue()
        ? customDateFormat(cell?.getValue(), "DD-MM-YYYY")
        : "N/A",
    // enableSorting: false,
  },
  {
    accessorKey: "blackListed",
    header: "Blacklisted",
    Cell: ({ cell }) => (cell?.getValue() ? "True" : "False"),
    enableSorting: false,
    size: 60,
  },
  {
    accessorKey: "isRedFlagged",
    header: "Red Flagged",
    Cell: ({ cell }) => (cell?.getValue() ? "True" : "False"),
    enableSorting: false,
    size: 60,
  },
  {
    accessorKey: "total",
    header: "Total",
    size: 60,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    // Cell: ({ cell }) => (!cell.getValue() && 'Null'),
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
  },
  {
    accessorKey: "valid",
    header: "Valid",
    size: 60,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    // Cell: ({ cell }) => (!cell.getValue() && 'Null'),
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
  },
  {
    accessorKey: "totalCampaigns",
    header: "Campaigns",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    // enableSorting: false
    size: 60,
  },
  {
    accessorKey: "totalSent",
    header: "Delivered",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    // enableSorting: false
    size: 60,
  },
  {
    accessorKey: "totalOpens",
    header: "Opens",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    // enableSorting: false
    size: 60,
  },
  {
    accessorKey: "totalClicks",
    header: "Clicks",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    // enableSorting: false
    size: 60,
  },
  {
    accessorKey: "totalBounced",
    header: "Bounced",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    // enableSorting: false
    size: 60,
  },
  {
    accessorKey: "openRate",
    header: "Open Rate",
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
    Cell: ({ cell }) => cell?.getValue().toFixed(1) + "%",
    // enableSorting: false
    size: 80,
  },
];

export const FilesColumns = [
  {
    accessorKey: "createdAt",
    header: "Uploaded on",
    enableSorting: false,
  },
  {
    accessorKey: "originalName",
    header: "Name",
    enableSorting: false,
  },
  {
    accessorKey: "status",
    header: "Status",
    enableSorting: false,
  },
  {
    accessorKey: "progress",
    header: "Progress",
    enableSorting: false,
  },
  {
    accessorKey: "_",
    header: "Actions",
    enableSorting: false,
  },
];

// export const campaignsListColumns = [
//     {
//       accessorKey: " ",
//       header: " ",
//       enableSorting: false,
//       size: 30,
//       Cell: ({ row }) => <ActionButton id={row.original.id} />,
//     },
//     {
//       accessorKey: "campaignTitle",
//       header: "Title",
//       enableSorting: false,
//       size: 200,
//       Cell: ({ cell }) => (
//         <div className="title-div" onClick={() => handleClick(cell.row.id)}>
//           {cell?.getValue()}
//         </div>
//       ),
//     },
//     {
//       accessorKey: "campaignSubject",
//       header: "Subject",
//       enableSorting: false,
//       size: 200,
//       Cell: ({ cell }) => (cell?.getValue() === "" ? "N/A" : cell?.getValue()),
//     },
//     {
//       accessorKey: "totalProcessed",
//       header: "Processed",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//     },
//     {
//       accessorKey: "totalSent",
//       header: "Delivered",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//     },
//     {
//       accessorKey: "totalOpen",
//       header: "Opened",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//     },
//     {
//       accessorKey: "clicks",
//       header: "Clicked",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//     },
//     {
//       accessorKey: "bounced",
//       header: "Bounced",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//     },
//     {
//       accessorKey: "blocked",
//       header: "Blocked",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//     },
//     {
//       accessorKey: "unsubScribed",
//       header: "Unsubscribed",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//     },
//     {
//       accessorKey: "openRate",
//       header: "Open Rate",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//       Cell: ({ cell }) => cell?.getValue().toFixed(1) + "%",
//     },
//     {
//       accessorKey: "clickRate",
//       header: "Click Rate",
//       enableSorting: true,
//       size: 40,
//       muiTableHeadCellProps: {
//         align: "center",
//       },
//       muiTableBodyCellProps: {
//         align: "center",
//       },
//       Cell: ({ cell }) => cell?.getValue().toFixed(1) + "%",
//     },
//   ];

export const campaignDetailsColumns = [
  {
    accessorKey: "email",
    header: "Email",
    enableSorting: false,
  },
  {
    accessorKey: "country",
    header: "Country",
    enableSorting: false,
    size: 60,
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
  },
  {
    accessorKey: "language",
    header: "Language",
    enableSorting: false,
    size: 60,
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
  },
  {
    accessorKey: "isVerified",
    header: "Verified",
    size: 60,
    Cell: ({ cell }) => (cell?.getValue() ? "True" : "False"),
    enableSorting: false,
  },
  {
    accessorKey: "blackListed",
    header: "Blacklisted",
    Cell: ({ cell }) => (cell?.getValue() ? "True" : "False"),
    enableSorting: false,
    size: 60,
  },
  {
    accessorKey: "isRedFlagged",
    header: "Red Flagged",
    Cell: ({ cell }) => (cell?.getValue() ? "True" : "False"),
    enableSorting: false,
    size: 60,
  },

  {
    accessorKey: "total",
    header: "Total",
    size: 60,
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
    // Cell: ({ cell }) => (!cell.getValue() && 'Null'),
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "valid",
    header: "Valid",
    size: 60,
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
    // Cell: ({ cell }) => (!cell.getValue() && 'Null'),
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "inValid",
    header: "Invalid",
    size: 60,
    Cell: ({ cell }) =>
      cell?.getValue() === ""
        ? "N/A"
        : cell?.getValue() === null
        ? "N/A"
        : cell?.getValue(),
    // Cell: ({ cell }) => (!cell.getValue() && 'Null'),
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "campaignOpens",
    header: "Opens",
    enableSorting: false,
    size: 60,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "campaignClicks",
    header: "Clicks",
    enableSorting: false,
    size: 60,
    muiTableHeadCellProps: {
      align: "center",
    },
    muiTableBodyCellProps: {
      align: "center",
    },
  },
  {
    accessorKey: "campaignBounced",
    header: "Bounced",
    enableSorting: false,
    size: 60,
    Cell: ({ cell }) => (cell.getValue() === 1 ? "True" : "False"),
  },
  // {
  //   accessorKey: "openRate",
  //   header: "Open Rate",
  //   Cell: ({ cell }) => cell?.getValue() + "%",
  //   enableSorting: false,
  // },
];
